import topBanner from "../images/top_banner.jpg";

//Slider Images
import sliderImage from "../images/home/imageSlider.png";

//Bot Images
import bot1 from "../images/home/bot1.png";
import bot2 from "../images/home/bot2.png";
import bot3 from "../images/home/bot3.png";
import bot4 from "../images/home/bot4.png";
import bot5 from "../images/home/bot5.png";
import bot6 from "../images/home/bot6.png";
import bot7 from "../images/home/bot7.png";
import bot8 from "../images/home/bot8.png";
import bot9 from "../images/home/bot9.png";
import botUtility from "../images/home/Nitro-Bot-Example.png";
//Big bots
import anoop from "../images/home/anoop.png";
import pitti from "../images/home/pitti.png";
import thakur from "../images/home/thakur.png";
import kall from "../images/home/kall.png";
//Multi Tier
import tier1 from "../images/home/multi/tier-1.png";
import tier2 from "../images/home/multi/tier-2.png";
import tier3 from "../images/home/multi/tier-3.png";
//hero Section Image
import hero1 from "../images/home/hero/1.png";
import hero2 from "../images/home/hero/2.png";
import hero3 from "../images/home/hero/3.png";
import hero4 from "../images/home/hero/4.png";
import hero5 from "../images/home/hero/5.png";
import hero6 from "../images/home/hero/6.png";
import heromain from "../images/home/hero/main.png";
//Gallery Bot
import gallery1 from "../images/nfm/gallery/1.png";
import gallery2 from "../images/nfm/gallery/2.png";
import gallery3 from "../images/nfm/gallery/3.png";
import gallery4 from "../images/nfm/gallery/4.png";
import gallery5 from "../images/nfm/gallery/5.png";
import gallery6 from "../images/nfm/gallery/6.png";
import gallery7 from "../images/nfm/gallery/7.png";
import gallery8 from "../images/nfm/gallery/8.png";
import gallery9 from "../images/nfm/gallery/9.png";
import gallery10 from "../images/nfm/gallery/10.png";
import gallery11 from "../images/nfm/gallery/11.png";
import gallery12 from "../images/nfm/gallery/12.png";

//Nfm Bot
import bot10 from "../images/nfm/8.png";
import bot11 from "../images/nfm/26.png";
import bot12 from "../images/nfm/36.png";
import bot13 from "../images/nfm/40.png";
import bot14 from "../images/nfm/47.png";
import bot15 from "../images/nfm/55.png";
import bot16 from "../images/nfm/62.png";
import bot17 from "../images/nfm/68.png";
import bot18 from "../images/nfm/70.png";
import bot19 from "../images/nfm/84.png";
import bot20 from "../images/nfm/103.png";
import bot21 from "../images/nfm/116.png";
import bot22 from "../images/nfm/126.png";
import bot23 from "../images/nfm/133.png";
import bot24 from "../images/nfm/140.png";
import bot25 from "../images/nfm/151.png";
import bot26 from "../images/nfm/160.png";
import bot27 from "../images/nfm/164.png";
import bot28 from "../images/nfm/176.png";
import bot29 from "../images/nfm/189.png";
import bot30 from "../images/nfm/195.png";
import bot31 from "../images/nfm/195.png";
import bot32 from "../images/nfm/203.png";
import bot33 from "../images/nfm/215.png";
import bot34 from "../images/nfm/250.png";
import bot35 from "../images/nfm/309.png";
import bot36 from "../images/nfm/318.png";
import bot37 from "../images/nfm/417.png";
import bot38 from "../images/nfm/440.png";
import bot39 from "../images/nfm/467.png";
import bot40 from "../images/nfm/509.png";
import bot41 from "../images/nfm/524.png";
import bot369 from "../images/nfm/3069.png";
import bot371 from "../images/nfm/3071.png";
import bot372 from "../images/nfm/3072.png";
import bot373 from "../images/nfm/3073.png";
import bot374 from "../images/nfm/3074.png";
import bot375 from "../images/nfm/3075.png";
import bot42 from "../images/nfm/trending/1.png";
import bot43 from "../images/nfm/trending/2.png";
import bot44 from "../images/nfm/trending/3.png";
import bot45 from "../images/nfm/trending/4.png";
import bot46 from "../images/nfm/trending/5.png";
import bot47 from "../images/nfm/trending/6.png";
import bot48 from "../images/nfm/trending/7.png";
import bot49 from "../images/nfm/trending/8.png";
import raid from "../images/nfm/raid.png";
//Color balls
import skyBall from "../images/home/skyball.png";
import pinkBall from "../images/home/pinkball.png";
import greenBall from "../images/home/greenball.png";
import yellowBall from "../images/home/yellowball.png";
import pinkRBall from "../images/home/pinkrball.png";

// buy nfm
import iconicMarketplace from "../images/marketplace/iconic.png";
import premiumMarketplace from "../images/marketplace/premium.png";
import topMarketplace from "../images/marketplace/top.png";
import bannerMarketplace from "../images/marketplace/banner.png";
import banner2Marketplace from "../images/marketplace/banner2.png";

import iconicEmi from "../images/iconic.png";
import premiumEmi from "../images/premium.png";
import topEmi from "../images/top.png";
import emiTier3 from "../images/emiTier3.png";
import mintBanner from "../images/mint-banner.png";

export const images = {
	topBanner,
	//slider images
	sliderImage,
	//Bot Images
	bot1,
	bot2,
	bot3,
	bot4,
	bot5,
	bot6,
	bot7,
	bot8,
	bot9,
	bot10,
	botUtility,
	//Nfm BOt
	bot11,
	bot12,
	bot13,
	bot14,
	bot15,
	bot16,
	bot17,
	bot18,
	bot19,
	bot20,
	bot21,
	bot22,
	bot23,
	bot24,
	bot25,
	bot26,
	bot27,
	bot28,
	bot29,
	bot30,
	bot31,
	bot32,
	bot33,
	bot34,
	bot35,
	bot36,
	bot37,
	bot38,
	bot39,
	bot40,
	bot41,
	bot42,
	bot43,
	bot44,
	bot45,
	bot46,
	bot47,
	bot48,
	bot49,
	raid,
	bot369,
	bot371,
	bot372,
	bot373,
	bot374,
	bot375,
	//Hero Section
	hero1,
	hero2,
	hero3,
	hero4,
	hero5,
	hero6,
	heromain,
	//Gallery
	gallery1,
	gallery2,
	gallery3,
	gallery4,
	gallery5,
	gallery6,
	gallery7,
	gallery8,
	gallery9,
	gallery10,
	gallery11,
	gallery12,
	//Big BOts
	anoop,
	pitti,
	kall,
	thakur,
	//multi Tier
	tier1,
	tier2,
	tier3,
	//Ball Images
	skyBall,
	pinkBall,
	greenBall,
	yellowBall,
	pinkRBall,

	// Available Bots Images
	iconicMarketplace,
	premiumMarketplace,
	topMarketplace,
	bannerMarketplace,
	banner2Marketplace,
	// images in emi
	iconicEmi,
	premiumEmi,
	topEmi,
	emiTier3,
	mintBanner,
};
